// extracted by mini-css-extract-plugin
export default {"container":"ProjectDetailItem_container__EKdxo","title":"ProjectDetailItem_title__L9nKI"};